function getYoutubeScript() {
  /**
   * The e.data values are taken from the Youtube iframe API at
   * https://developers.google.com/youtube/iframe_api_reference
   * and are;
   * -1 - video 'unstarted' (we don't use this value)
   * 0  - video ended
   * 1  - video playing
   * 2  - video paused
   * 3  - video buffering (we don't use this value)
   * 5  - video cued (we don't use this value)
   */
  return `
    (function () {
      const playerStates = ["ended", "playing", "paused", "buffering", "videoCued"];
      let playerData = {};
      let hasInitialised = false;
  
      if (window.YT) {
        window.YT.ready(() => {
          setTimeout(() => {
            init();
          }, 500);
        });
      }
      
  
      window.onYouTubeIframeAPIReady = () => {
        init();
      }
  
      function init() {
        if (!hasInitialised) {
          const iframes = Array.from(document.getElementsByClassName('yt-player-custom'));
          iframes.forEach(iframe => {
            const player = new YT.Player(iframe.id, {
              events: {
                'onStateChange': onPlayerStateChange
              }
            });
            playerData[iframe.id]  = {
              videoPoller: null,
              percentRun: -1,
              hasFinished: false,
              videoPlayed: false,
              lastPlayerState: "",
            }
          });
        }
        hasInitialised = true;
      }
  
      function onPlayerStateChange(e) {
        const id = e.target.getIframe().id;
        if (e.data === 1) {
          if (!playerData[id].videoPlayed) {
            update(e, 0);
            playerData[id].videoPlayed = true;
          }
          playerData[id].videoPoller = setInterval(function() {
            if (document.getElementById(id)) {
              update(e);
            } else {
              clearInterval(playerData[id].videoPoller);
            }
          }, 2000);
        } else if (e.data===2) {
          update(e)
          clearInterval(playerData[id].videoPoller);
        } else if (e.data===0) {
          if (!playerData[id].hasFinished) {
            update(e);
            playerData[id].hasFinished = true;
          }
          clearInterval(playerData[id].videoPoller);
        }
      }
  
      function update(event, percent=null) {
        const thePlayer = event.target;
        const id = event.target.getIframe().id;
        const currentTime = thePlayer.getCurrentTime();
        const duration = thePlayer.getDuration()
        const playerState = playerStates[thePlayer.getPlayerState()];
        const videoUrl = thePlayer.getVideoUrl();
        const newPercent = percent===null ? Math.floor(thePlayer.getVideoLoadedFraction()*10)*10 : percent;
        
        if (newPercent > playerData[id].percentRun || playerState!==playerData[id].lastPlayerState) {
          // Change the percent only if it is higher than the previous value.
          if (newPercent > playerData[id].percentRun) {
            playerData[id].percentRun = newPercent;
          }
          if (window.onVhubYtEvent) {
            const eventData = {
              type:'ytVideoEvent',
              percentRun:playerData[id].percentRun,
              currentTime,
              duration,
              playerState,
              videoUrl,
              source: {player: thePlayer, event},
            };
            window.onVhubYtEvent(eventData);
          }
        }
        playerData[id].lastPlayerState = playerState;
      }
    })();`;
}

export default getYoutubeScript;
